import React from "react";
import { formatCurrency } from "../../config/siteConfig";

const VariantSelector = ({ variants, value, onChange }) => (
  <fieldset className="variant-selector">
    <legend>Choose a size</legend>
    <div className="variant-selector__options">
      {variants.map((variant) => {
        const unavailable = Number(variant.stock) <= 0;
        return (
          <label className={value?.id === variant.id ? "is-selected" : ""} key={variant.id}>
            <input type="radio" name="variant" value={variant.id} checked={value?.id === variant.id} onChange={() => onChange(variant)} disabled={unavailable} />
            <span><strong>{variant.name}</strong><small>{variant.size}</small></span>
            <span><strong>{formatCurrency(variant.price)}</strong>{unavailable && <small>Sold out</small>}</span>
          </label>
        );
      })}
    </div>
  </fieldset>
);

export default VariantSelector;
